import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProdutoService {
  private data = null;
  private url = environment.serviceApi;
  constructor(public http: Http) { }

  getProdutos() {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/produto')
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getProduto(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/produto/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  criaProduto(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/produto', {
				produto_codigo: data.produto_codigo,
				produto_descricao: data.produto_descricao,
				fornecedor_id: data.fornecedor_id,
				grupo_produto_id: data.grupo_produto_id,
				produto_localizacao: data.produto_localizacao,
				produto_qtd_min: data.produto_qtd_min,
				produto_qtd: data.produto_qtd,
				produto_qtd_inicial: data.produto_qtd,
				unidade_medida_id: data.unidade_medida_id,
				produto_data_validade: data.produto_data_validade,
				produto_lote: data.produto_lote,
				is_produto_lote: data.is_produto_lote
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaProduto(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/produto/' + data.produto_id, {
				produto_codigo: data.produto_codigo,
				produto_descricao: data.produto_descricao,
				fornecedor_id: data.fornecedor_id,
				grupo_produto_id: data.grupo_produto_id,
				produto_localizacao: data.produto_localizacao,
				produto_qtd_min: data.produto_qtd_min,
				produto_qtd: data.produto_qtd,
				produto_qtd_inicial: data.produto_qtd,
				unidade_medida_id: data.unidade_medida_id,
				produto_data_validade: data.produto_data_validade,
				produto_lote: data.produto_lote,
				is_produto_lote: data.is_produto_lote
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaProduto(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/produto/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
